import { useAui } from '@assistant-ui/react';
import { Button, Modal, Stack, Textarea } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconBug } from '@tabler/icons-react';
import { useState } from 'react';

import { DownloadButton } from '#core/components/shared/DownloadButton.tsx';

import { buildDiagnosticReport } from '#plugin-chat/lib/transport/diagnosticReport.ts';

/** Button with modal form for reporting issues, bundling thread diagnostic data into a downloadable JSON file. */
export function ReportIssue() {
  const [opened, { open, close }] = useDisclosure(false);
  const [description, setDescription] = useState('');
  const aui = useAui();

  return (
    <>
      <Button fullWidth leftSection={<IconBug size={14} />} onClick={open} size="xs" variant="subtle">
        Report issue
      </Button>

      <Modal centered onClose={close} opened={opened} title="Report issue">
        <Stack>
          <p>
            Describe the issue you encountered. Your diagnostic data will be included in the downloaded report. Share
            the downloaded file with the support team.
          </p>
          <Textarea
            autosize
            label="Issue description"
            minRows={3}
            onChange={(e) => setDescription(e.currentTarget.value)}
            placeholder="Describe what happened..."
            value={description}
          />
          <DownloadButton
            getData={() =>
              JSON.stringify(
                buildDiagnosticReport({
                  repo: aui.thread().export(),
                  threadId: aui.threadListItem().getState().id,
                  description,
                  reportedAt: new Date().toISOString(),
                }),
                null,
                2,
              )
            }
            getFileName={() => `issue-report-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.json`}
            label="Download diagnostic report"
            mimeType="application/json"
            onClick={() => {
              setDescription('');
              close();
            }}
          />
        </Stack>
      </Modal>
    </>
  );
}
